import { FlattenedAttachment } from "@components/asset/modal/tabs/edit/EditTabTypes";

interface Attachment {
    filename: string | undefined;
    url: string | undefined;
}

/**
 * Get the first PDF attachment's filename and url.
 * Note that if a PDF attachment isn't found, filename and url will be undefined;
 * @param {Asset} asset Asset
 * @returns {Attachment} Attachment
 */
export const getPdfAttachment = (attachments: FlattenedAttachment[]): Attachment => {
  const pdfAttachment: Attachment = { filename: undefined, url: undefined };

  const attachment = attachments.find((a) => a.extension === 'pdf');
  if (attachment) {
    pdfAttachment.filename = attachment.filename;
    pdfAttachment.url = attachment.url;
  }

  return pdfAttachment;
};
